import { styled } from 'stitches.config'

export const StartrRoot = styled('div', {
  backgroundColor: '$tertiary-200',
  width: '100%',
  position: 'relative',
  '@bp2': {},

  '& strong': {
    fontWeight: '$semiBold',
  },
})
